var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", staticStyle: { padding: "10px" } },
    [
      _c("div", { staticClass: "content mt20" }, [
        _c("div", { staticClass: "container-flex-k" }, [
          _c(
            "div",
            { staticClass: "container-leftflex-k" },
            [
              _c(
                "div",
                { staticClass: "container-leftflextop-k" },
                [
                  _vm._m(0),
                  _c(
                    "el-button",
                    {
                      staticClass: "add-bu-k",
                      attrs: { type: "primary" },
                      on: { click: _vm.addRole }
                    },
                    [_vm._v("添加角色")]
                  )
                ],
                1
              ),
              _c("el-alert", {
                staticClass: "mt10",
                attrs: { title: "双击角色可编辑", type: "warning" }
              }),
              _c(
                "el-menu",
                {
                  staticClass: "mt20",
                  attrs: { "default-active": "1" },
                  on: { select: _vm.roleSelect }
                },
                _vm._l(_vm.rolesList, function(item, index) {
                  return _c(
                    "el-menu-item",
                    {
                      key: index,
                      attrs: { index: item.roleId },
                      nativeOn: {
                        mouseenter: function($event) {
                          return _vm.selectStyle(item)
                        },
                        mouseleave: function($event) {
                          return _vm.outStyle(item)
                        },
                        dblclick: function($event) {
                          return _vm.editRole(item)
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(item.roleNameDisplay))]),
                      item.roleId != 1 && item.isShowDelete
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  title: "删除"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.delRole(item.roleId)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-delete" })]
                            )
                          ])
                        : _vm._e(),
                      index > 0 && item.isShowDelete
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  title: "上移"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.changeOrder(item.roleId, 0)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-top" })]
                            )
                          ])
                        : _vm._e(),
                      index != _vm.rolesList.length - 1 && item.isShowDelete
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  title: "下移"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.changeOrder(item.roleId, 1)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-bottom" })]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "container-rightflex-k" },
            [
              _vm.isShowButton
                ? _c(
                    "el-button",
                    {
                      staticClass: "rightfile-bu-k add-bu-k",
                      attrs: {
                        type: "primary",
                        loading: _vm.saveChangeLoading
                      },
                      on: { click: _vm.saveChange }
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "用户组成员", name: "first" } },
                    [
                      _c(
                        "div",
                        { staticClass: "search-box" },
                        [
                          _c(
                            "el-form",
                            {
                              staticClass: "demo-form-inline",
                              attrs: { inline: true, model: _vm.form }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "搜索：" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入关键字" },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.searchTo()
                                      }
                                    },
                                    model: {
                                      value: _vm.keyword,
                                      callback: function($$v) {
                                        _vm.keyword = $$v
                                      },
                                      expression: "keyword"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.searchTo()
                                        }
                                      }
                                    },
                                    [_vm._v("查询")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("pagination-table", {
                        ref: "table",
                        attrs: {
                          data: _vm.customerList,
                          columns: _vm.columns,
                          loader: _vm.fetchRoleCustomer,
                          async: true,
                          pageSizes: [20]
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "权限配置", name: "second" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.roleTableLoading,
                              expression: "roleTableLoading"
                            }
                          ],
                          attrs: {
                            data: _vm.authority,
                            "row-class-name": "table-row-class-name",
                            "header-row-style": {
                              background: "transparent"
                            }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "操作对象",
                              prop: "groupName",
                              width: "200"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.groupName))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { label: "权限", prop: "functionList" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        on: {
                                          change: function($event) {
                                            return _vm.handleCheckedFeaturesChange(
                                              scope
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.checkedFeatures,
                                          callback: function($$v) {
                                            _vm.checkedFeatures = $$v
                                          },
                                          expression: "checkedFeatures"
                                        }
                                      },
                                      _vm._l(scope.row.functionList, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: index,
                                            attrs: { label: item.functionId }
                                          },
                                          [_vm._v(_vm._s(item.functionName))]
                                        )
                                      }),
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { label: "全选", width: "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-checkbox", {
                                      key: scope.$index,
                                      attrs: {
                                        indeterminate: scope.row.isIndeterminate
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleCheckAllChange(scope)
                                        }
                                      },
                                      model: {
                                        value: scope.row.ionsChecked,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "ionsChecked",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.ionsChecked"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [
            { name: "drag", rawName: "v-drag:common", arg: "common" }
          ],
          attrs: {
            visible: _vm.dialog.visible,
            title: "角色信息",
            width: "500px",
            "show-close": false
          },
          on: { close: _vm.cancelDialog }
        },
        [
          _c(
            "el-form",
            {
              ref: "dialog",
              attrs: {
                rules: _vm.dialog.rule,
                model: _vm.dialog.data,
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "roleName" } },
                [
                  _c("span", { staticClass: "jsname" }, [_vm._v("角色名称")]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { placeholder: "请输入角色名称", maxlength: 30 },
                    model: {
                      value: _vm.dialog.data.roleName,
                      callback: function($$v) {
                        _vm.$set(_vm.dialog.data, "roleName", $$v)
                      },
                      expression: "dialog.data.roleName"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "lobu-k" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { id: "quxiao-bu-k" },
                        on: { click: _vm.cancelDialog }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.dialog.loading },
                        on: {
                          click: function($event) {
                            return _vm.save()
                          }
                        }
                      },
                      [_vm._v("确认")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("span", [_vm._v("角色名称")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }